import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import {imagesRegister} from "../../services/imagesRegister";
import {quotesRegister} from "../../services/quotesRegister";
import Information from "../../components/information/component";
import BoosterHeader from "../../components/booster-header/component";
import {scraperRegister} from "../../services/scraperRegister";
import {themeRegister} from "../../services/themeRegister";
import {videoRegisterNew} from "../../services/videoRegisterNew";

class SignUpTheme extends Component {

    constructor(props) {
        super(props);
        this.state = {
            themes: [],
            selected: null
        };
    };

    componentWillMount() {

        window.scrollTo(0, 0);

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/signup/theme');
            ReactGA4.send({ hitType: "pageview", page: "/signup/theme" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

        //remove custom upload
        videoRegisterNew.setCustom(null, null);

        this.update.theme();
        this.update.themes();

    }

    update = {
        theme: () => {
            if(themeRegister.getValue()){
                this.setState({
                    selected: themeRegister.getTheme()
                }, () => {
                    console.log(this.state.selected);
                })
            }
        },
        themes: () => {
            let themes = [
                {id: "promotion", default: false, display: false, recommended: true, type: "saleschannel", title: "promotion", title_italian: "in focus", subtitle: "builds your ads with attention to your property's value added"},
                {id: "basic", default: true, display: true, recommended: false, type: "saleschannel", title: this.renders.text("item_2"), subtitle: this.renders.text("item_3")},
            ];
            this.setState({
                themes: themes
            })
        }
    };

    functions = {
        select: (id) => {
            this.setState({selected: id}, () => {
                themeRegister.setTheme(id);
                setTimeout(() => {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get("name") + "/signup/ads");
                }, 200);
            })
        },
        back: () => {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get("name")+ "/signup/business");
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("signup-theme", item);
        },
        last: () => {
            return Math.abs(this.state.themes.filter((item) => {
                return item.display
            }).length % 2) == 1 && this.state.themes.length > 3;
        }
    };
    render() {
        return (
            <div>
                <HeaderSignupOne history={this.props.history} view={"signup"} props={this.props}/>
                <div className={Styles.containerOuter}>
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            <div>
                                {this.renders.text("item_1")}
                            </div>
                        </div>
                        <div className={Styles.optionsContainer}>
                            {
                                this.state.themes.filter((item) => {
                                    return item.display
                                }).map((item) => {
                                    return(
                                        <div className={Styles.optionsContainerItem}>
                                            <div className={Styles.optionsContainerItemInner}>
                                                {
                                                    item.recommended &&
                                                    <div className={Styles.optionsContainerItemInnerBadge}>
                                                        RECOMMENDED
                                                    </div>
                                                }
                                                <div onClick={() => this.functions.select(item.id)} className={cx(Styles.optionsContainerItemInnerLayer)}>
                                                    <div className={
                                                        cx(Styles.optionsContainerItemInnerTitle,
                                                            {
                                                                [Styles.optionsContainerItemInnerTitleDefault]: item.default,
                                                            })
                                                    }>
                                                        {item.title}
                                                        {
                                                            item.title_italian &&
                                                            <div className={Styles.optionsContainerItemInnerTitleItalian}>{item.title_italian}</div>
                                                        }
                                                    </div>
                                                    <div className={Styles.optionsContainerItemInnerSubtitle}>
                                                        {item.subtitle}
                                                    </div>
                                                </div>
                                                {
                                                    this.state.selected === item.id &&
                                                    <div onClick={() => this.functions.select(item.id)} className={Styles.optionsContainerItemInnerActive}/>
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            {
                                this.renders.last() &&
                                <div className={Styles.optionsContainerItemLast}/>
                            }
                        </div>
                        {
                            <div
                                onClick={() => this.functions.back()}
                                className={cx(Styles.backButton)}>
                                {this.renders.text("item_4")}
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default SignUpTheme;


// WEBPACK FOOTER //
// ./src/pages/signup-theme/component.js